import React from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { ChordNode } from "./ChordChart";
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";

export interface ChordChartRibbonTooltipProps {
  sourceBucket: ChordNode;
  targetBucket: ChordNode;
  sourceColor: string;
  targetColor: string;
  sharedConnectionCount: number;
}

// Tooltip content component
export default function ChordChartRibbonTooltip(props: ChordChartRibbonTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  
  const sourcePercentage = props.sharedConnectionCount / props.sourceBucket._count;
  const targetPercentage = props.sharedConnectionCount / props.targetBucket._count;

  return (
    <>
      {/* Bucket Labels */}
      <Typography sx={{ mb: 1, display: "flex", justifyContent: "space-between" }} variant="h4">
        <span style={{color: props.sourceColor}}>{props.sourceBucket._label}</span>
        <span>{i18n.t("and")}</span>
        <span style={{color: props.targetColor}}>{props.targetBucket._label}</span>
      </Typography>
      <Box sx={{display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", mb: 1}}>
        <Box sx={{textAlign: "left"}}>
          <ISONumber sx={{ fontWeight: "bold", color: props.sourceColor}} number={props.sourceBucket._count} />
        </Box>
        <Typography >{i18n.t("total")}</Typography>
        <Box sx={{textAlign: "right"}}>
          <ISONumber sx={{ fontWeight: "bold", color: props.targetColor }} number={props.targetBucket._count} />
        </Box>
      </Box>
      {/* Shared Count */}
      <Stack
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 1
        }}>
        <Typography sx={{
          marginRight: 1
        }}>{i18n.t("widget-types.chord-chart.shared-records")}:</Typography>
        <ISONumber sx={{ fontWeight: "bold" }} number={props.sharedConnectionCount} />
      </Stack>
      <Box sx={{display: "grid", gridTemplateColumns: "1fr auto 1fr", mb: 1}}>
        <Box sx={{textAlign: "left"}}>
          <ISOPercentage
            sx={{
              color: props.sourceColor,
              fontWeight: "bold"
            }}
            value={sourcePercentage}
          />
        </Box>
        <Typography>{i18n.t("widget-types.chord-chart.of-total")}</Typography>
        <Box sx={{textAlign: "right"}}>
            <ISOPercentage
              sx={{
                color: props.targetColor,
                fontWeight: "bold"
              }}
              value={targetPercentage}
            />
        </Box>
      </Box>
    </>
  );
};
